import { useNavigate } from 'react-router-dom';
import FmCard from '../components/FmCard.jsx';
import { YELLOW_CARD, RED_CARD } from '../data/penalties.js';

export default function Rules() {
  const navigate = useNavigate();
  return (
    <div className="rules-page">
      <button
        className="back-btn"
        onClick={() => navigate(-1)}
        style={{ marginTop: 'env(safe-area-inset-top)' }}
      >
        ←
      </button>
      <h1>Pub Golf</h1>
      <div className="rules-sub">The Social Bar Crawl Experience</div>

      <section>
        <h2>Object</h2>
        <p>
          Travel the course from venue to venue. At each hole, the group
          completes the assigned drink in as few sips as possible. The team
          with the fewest total strokes wins.
        </p>
      </section>

      <section>
        <h2>Par</h2>
        <p>
          Every hole has a par set by its difficulty (typically 2–5). Strokes
          above par add to your score; strokes below par subtract.
        </p>
      </section>

      <section>
        <h2>The Caddy</h2>
        <p>
          The designated caddy records scores, watches for infractions, and
          settles disputes. Caddies can be rotated each hole when Caddy Mode
          is enabled.
        </p>
      </section>

      <section>
        <h2>Infractions</h2>
        <p>
          The Caddy is the sole judge. Any player may be issued a card at any
          point during the round.
        </p>

        {[YELLOW_CARD, RED_CARD].map((card) => (
          <div key={card.type} className={`rules-penalty rules-penalty-${card.type}`}>
            <div className="rules-penalty-header">
              <FmCard type={card.type} size="lg" />
              <div>
                <h3>{card.label}</h3>
                <span>{card.description} each</span>
              </div>
            </div>
            <p className="rules-penalty-blurb">{card.blurb}</p>
            <ul className="rules-penalty-list">
              {card.infractions.map((reason) => (
                <li key={reason}>{reason}</li>
              ))}
            </ul>
          </div>
        ))}
      </section>

      <section>
        <h2>The Two Yellows Rule</h2>
        <div className="rules-twoyellows">
          <div className="rules-twoyellows-visual">
            <FmCard type="yellow" size="lg" />
            <span className="plus">+</span>
            <FmCard type="yellow" size="lg" />
            <span className="arrow">→</span>
            <FmCard type="red" size="lg" />
          </div>
          <p>
            Two yellow cards on the same player automatically convert to a
            red. The first yellow is worth <strong>+1 stroke</strong>, but the
            second yellow becomes worth <strong>+2 strokes</strong>, making
            the pair worth <strong>+3 strokes total</strong>.
          </p>
          <p>
            A third yellow earns +1 stroke, and a fourth converts again — and
            so on.
          </p>
        </div>
      </section>

      <section>
        <h2>Water Hazards</h2>
        <p>
          Certain holes are designated as <strong>Water Hazards</strong> by
          the Caddy or the course. Look for the{' '}
          <span className="rules-hazard-chip">💧 HAZARD</span> chip on a
          venue card.
        </p>
        <p>
          Use of the lavatory at a Water Hazard hole earns the offender an
          immediate yellow card. Plan accordingly.
        </p>
      </section>

      <section>
        <h2>Designated Drivers</h2>
        <p>
          Any player may toggle DD mode at any hole. Their strokes are tracked
          independently and never affect team totals.
        </p>
      </section>

      <section>
        <h2>Champion</h2>
        <p>
          After the final hole, the team with the fewest total strokes is
          crowned the champion of the night.
        </p>
      </section>
    </div>
  );
}
